<template>
  <div>
    <!-- {{ postID }} -->
    <div v-if="$store.getters.isAuthenticated">
      <button class="mylisting-button dark-button mb-4" @click="showCommentModal()">Comment</button>
    </div>
    <div v-if="comments.length == 0" class="mt-3">
      <p>No comments yet.</p>
    </div>
    <div v-if="comments.length > 0" class="mt-3">
      <div v-for="comment in comments" :key="comment.id">
        <p>{{ comment.content }}</p>
        <p class="mt-2">Posted by: {{ comment.poster_name }}</p>
        <p>{{ (new Date(comment.created_date)).toDateString() }}</p>
        <div v-if="user.is_agent">
          <button class="mylisting-button dark-button" @click="unpublishComment(comment)">Unpublish Comment</button>
          <p class="mt-2" style="color: red; cursor: pointer;" @click="deleteComment(comment)">Delete Comment</p>
        </div>
        <hr>
      </div>
    </div>
    <div v-if="user.is_agent && unpublishedComments.length > 0" class="mt-3">
      <h3>Unpublished Comments</h3>
      <hr>
      <div v-for="comment in unpublishedComments" :key="comment.id">
        <p>{{ comment.content }}</p>
        <p class="mt-2">Posted by: {{ comment.poster_name }}</p>
        <p>{{ (new Date(comment.created_date)).toDateString() }}</p>
        <button class="mylisting-button dark-button" @click="publishComment(comment)">Publish Comment</button>
        <p class="mt-2" style="color: red; cursor: pointer;" @click="deleteComment(comment)">Delete Comment</p>
        <hr>
      </div>
    </div>
    <div v-if="user.is_agent && unpublishedComments.length == 0">
      <hr>
      <p>No unpublished comments.</p>
    </div>

    <modal name="comment-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-4">
        <h2>Add a Comment</h2>
        <hr>
        <textarea class="form-control" rows="5" v-model="commentText"></textarea>
        <hr>

        <button class="mylisting-button secondary-button" @click="hideCommentModal()">Cancel</button>
        <button class="mylisting-button dark-button" style="float: right;" @click="submitComment()">Submit</button>
      </div>
    </modal>

    <modal name="comment-submitted-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-4">
        <h2>Thanks for your comment!</h2>
        <!-- <hr> -->
        <p>It will appear here once it has been reviewed by our administrative team.</p>
        <hr>
        <button class="mylisting-button dark-button" @click="hideCommentSubmittedModal()">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['postID', 'blogPost'],
  data() {
    return {
      comments: [],
      unpublishedComments: [],
      commentText: '',
      user: {},
    }
  },
  created() {
    this.getComments()

    if (this.$store.getters.userID) {
      this.getUser()
    }
  },
  methods: {
    getComments() {
      axios.get('/api/blogcomments/?published=true&blog_post='+this.postID.toString())
        .then(res => {
          console.log(res)
          this.comments = res.data
        })
        .catch(error => {
          console.log(error)
        })
      axios.get('/api/blogcomments/?published=false&blog_post='+this.postID.toString())
        .then(res => {
          console.log(res)
          this.unpublishedComments = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getUser() {
      axios.get('/api/people/'+this.$store.getters.userID.toString())
        .then(res => {
          console.log(res)
          this.user = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showCommentModal() {
      this.$modal.show('comment-modal')
    },
    hideCommentModal() {
      this.$modal.hide('comment-modal')
    },
    submitComment() {
      let name = ''
      if (this.user.is_candidate) {
        name = this.user.first_name + ' ' + this.user.last_name
      }
      if (this.user.is_employer) {
        name = this.user.employer_name
      }

      axios.post('/api/blogcomments/', {
        poster: this.$store.getters.userID,
        poster_name: name,
        blog_post: this.postID,
        content: this.commentText,
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName,
      })
        .then(res => {
          console.log(res)
          this.hideCommentModal()
          this.$modal.show('comment-submitted-modal')

          this.$store.dispatch('sendEmail',
            {
              subject: 'New Blog Comment',
              message: 'New comment on blog post with the title: '+this.blogPost.title+'\n'+'https://www.thrivehire.co/blog-post/'+this.blogPost.id.toString()+'\n\n'+this.commentText+'\n\nPosted By: '+name,
              // from: 'info@thrivehire.co',
              from: 'info@thrivehire.co',
              email: 'info@thrivehire.org',
              reply: 'info@thrivehire.co',
              // userID: this.aakashid,
              userID: 4, // Hard coding to my production ID for now
            }
          )
          this.$store.dispatch('sendEmail',
            {
              subject: 'New Blog Comment',
              message: 'New comment on blog post with the title: '+this.blogPost.title+'\n'+'https://www.thrivehire.co/blog-post/'+this.blogPost.id.toString()+'\n\n'+this.commentText+'\n\nPosted By: '+name,
              // from: 'info@thrivehire.co',
              from: 'info@thrivehire.co',
              email: 'aakash@enginehire.ca',
              reply: 'info@thrivehire.co',
              // userID: this.aakashid,
              userID: 4, // Hard coding to my production ID for now
            }
          )
        })
        .catch(error => {
          console.log(error)
        })
    },
    hideCommentSubmittedModal() {
      this.$modal.hide('comment-submitted-modal')
    },
    publishComment(comment) {
      axios.patch('/api/blogcomments/'+comment.id.toString()+'/', {
        published: true,
      })
        .then(res => {
          console.log(res)
          this.getComments()
        })
        .catch(error => {
          console.log(error)
        })
    },
    unpublishComment(comment) {
      axios.patch('/api/blogcomments/'+comment.id.toString()+'/', {
        published: false,
      })
        .then(res => {
          console.log(res)
          this.getComments()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteComment(comment) {
      axios.delete('/api/blogcomments/'+comment.id.toString()+'/')
        .then(res => {
          console.log(res)
          this.getComments()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/blog/Comments.vue